import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'multiselectSearch'
})
export class MultiselectSearchPipe implements PipeTransform {

  transform(value: any, searchKey: string, searchValue: string): any {
    if(!value || !searchValue) return value;
    return value.filter(option => option[searchKey].toLowerCase().indexOf(searchValue.toLowerCase()) != -1);
  }

}
